
import { supabase } from "@/integrations/supabase/client";
import { ReagentRequest } from "@/types/reagentRequest.types";
import { toast } from "sonner";
import { createLogger } from "@/services/utils/loggingUtils";

const logger = createLogger("UpdateRequestService");

// Update a reagent request
export const updateReagentRequest = async (id: string, updateData: Partial<ReagentRequest>): Promise<boolean> => {
  try {
    // Remove any fields that shouldn't be updated
    const { id: _, profiles, categories, created_at, is_deleted, is_fulfilled, ...updatableData } = updateData as any;
    
    // Add updated timestamp
    const dataToUpdate = {
      ...updatableData,
      updated_at: new Date().toISOString()
    };
    
    logger.info("Updating reagent request with data:", dataToUpdate);
    
    const { error } = await supabase
      .from("reagent_requests")
      .update(dataToUpdate)
      .eq("id", id);

    if (error) {
      logger.error("Error updating reagent request:", error);
      toast.error("Failed to update reagent request: " + error.message);
      return false;
    }

    logger.info("Reagent request updated successfully");
    toast.success("Reagent request updated successfully!");
    return true;
  } catch (error) {
    logger.error("Exception in updateReagentRequest:", error);
    return false;
  }
};
